module.exports = __webpack_public_path__ + "od-unchecked/od-unchecked-bf7795b993163d1a26f5bdda914a448b.svg";